import foodie from "../img/foodie_figma.png";
import moonKnight from "../img/moonknight_figma.png";
import foodieVite from "../img/foodie.png";
import vueBloogy from "../img/bloogyVue.png";
import bootstrapTheme from "../img/bootstrapTheme.png";
import projectPlanner from "../img/projectPlanner.png";
import socialMediaHome from "../img/socialMediaPhotos/HomePage.png";
import socialMediaProfile from "../img/socialMediaPhotos/ProfilePage.png";
import socialMediaEcommerce from "../img/socialMediaPhotos/EcommercePage.png";
import bootstrapPremiumTheme from "../img/socialMediaPhotos/bootstrapPremiumTheme.png";
import customerImg from "../img/socialMediaPhotos/curstomersPage.png";

export const data = [
  {
    id: 1,
    title: "Social Media Home Page",
    price: 599,
    description:
      "This is social Media Home Page(Still Writing, Please patiently wait some minute when entering social media web)",
    image: socialMediaHome,
    url: "https://socialmedia-by-shp.netlify.app/",
    rating: {
      rate: 5,
      count: 120,
    },
  },
  {
    id: 2,
    title: "Social Media Ecommerce page",
    price: 599,
    description:
      "This is Social Media Ecommerce page(Still Writing, Please patiently wait some minute when entering social media web)",
    image: socialMediaEcommerce,
    url: "https://socialmedia-by-shp.netlify.app/ecommerce",
    rating: {
      rate: 5,
      count: 120,
    },
  },
  {
    id: 3,
    title: "Customer Relationship Management",
    price: 599,
    description:
      "To login you need maill and password username=> sai@gmail.com password => sai@123",
    image: customerImg,
    url: "https://assignment-k.netlify.app/",
    rating: {
      rate: 5,
      count: 120,
    },
  },
  {
    id: 4,
    title: "Social Media Profile Page",
    price: 599,
    description:
      "This is Social Media Profile Page(Still Writing, Please patiently wait some minute when entering social media web)",
    image: socialMediaProfile,
    url: "https://socialmedia-by-shp.netlify.app/profile",
    rating: {
      rate: 5,
      count: 120,
    },
  },

  {
    id: 5,
    title: "Bootstrap Responsive Premium Theme",
    price: 599,
    description: "This is Bootstrap Responsive Premium Theme",
    image: bootstrapPremiumTheme,
    url: "https://bootstrap-premium-theme.netlify.app/",
    rating: {
      rate: 5,
      count: 120,
    },
  },
  {
    id: 6,
    title: "Figma Foodie Projects",
    price: 100,
    description: "This is Figma Foodie Project",
    image: foodie,
    url: "https://www.figma.com/proto/4K79HqdqO4FyxfxTfmOhKZ/Food-Web-Design?node-id=2%3A2&scaling=min-zoom&page-id=0%3A1&starting-point-node-id=2%3A2",
    rating: {
      rate: 3.9,
      count: 120,
    },
  },
  {
    id: 7,
    title: "Figma Moon Knight Projects",
    price: 100,
    description: "This is Figma Moon Knight Projects",
    image: moonKnight,
    url: "https://www.figma.com/proto/4K79HqdqO4FyxfxTfmOhKZ/Food-Web-Design?node-id=2%3A2&scaling=min-zoom&page-id=0%3A1&starting-point-node-id=2%3A2",
    rating: {
      rate: 3.9,
      count: 120,
    },
  },
  {
    id: 8,
    title: "Vite Foodie Projects",
    price: 100,
    description: "This is Vite Foodie Projects",
    image: foodieVite,
    url: "https://www.figma.com/proto/4K79HqdqO4FyxfxTfmOhKZ/Food-Web-Design?node-id=2%3A2&scaling=min-zoom&page-id=0%3A1&starting-point-node-id=2%3A2",
    rating: {
      rate: 3.9,
      count: 120,
    },
  },
  {
    id: 9,
    title: "Vue Blog Projects",
    price: 100,
    description: "This is Vue Blog Projects",
    image: vueBloogy,
    url: "https://www.figma.com/proto/pMFuP9ElN3AWbUQeFbz9oc/Untitled?node-id=13%3A2&starting-point-node-id=13%3A2",
    rating: {
      rate: 3.9,
      count: 120,
    },
  },
  {
    id: 10,
    title: "Bootstrap premium theme projects",
    price: 100,
    description: "This is Bootstrap premium theme projects",
    image: bootstrapTheme,
    url: "https://www.figma.com/proto/pMFuP9ElN3AWbUQeFbz9oc/Untitled?node-id=13%3A2&starting-point-node-id=13%3A2",
    rating: {
      rate: 3.9,
      count: 120,
    },
  },
  {
    id: 11,
    title: "Vue project planner",
    price: 100,
    description: "This is Vue project planner",
    image: projectPlanner,
    url: "https://www.figma.com/proto/pMFuP9ElN3AWbUQeFbz9oc/Untitled?node-id=13%3A2&starting-point-node-id=13%3A2",
    rating: {
      rate: 3.9,
      count: 120,
    },
  },
];
